import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useAuthUserData, useDocumentId, useDocumentSecurity } from 'hooks';
import InsuranceDocumentPageContainer from './InsuranceDocumentPageContainer';

const InsuranceDocumentRootContainer = ({ contextRef }) => {
  const history = useHistory();
  const { authUser } = useAuthUserData();
  const { documentId, isNew } = useDocumentId();
  const { access } = useDocumentSecurity(documentId);

  useEffect(() => {
    if (access === false) {
      history.push('/forbidden');
    }
  }, [access, history]);

  return authUser && (access || isNew) ? <InsuranceDocumentPageContainer contextRef={contextRef} /> : '';
};

InsuranceDocumentRootContainer.propTypes = {
  contextRef: PropTypes.shape({
    current: PropTypes.shape({
      properties: PropTypes.object.isRequired,
      events: PropTypes.shape({
        onChangeDocumentStateFailed: PropTypes.array.isRequired,
        onDocumentStateUpdated: PropTypes.func.isRequired
      }),
      functions: PropTypes.object.isRequired
    })
  })
};

export default InsuranceDocumentRootContainer;
